import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks';

interface RequireAuthProps {
  children: JSX.Element;
  allowedRoles?: string[];
}

export function RequireAuth({ children, allowedRoles }: RequireAuthProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    if (user) {
      const hasRole = allowedRoles.includes(user.role);
      const isPartnerAllowed =
        allowedRoles.includes('PARTNER') &&
        (user.role === ('PARTNER' as any) || user.isPartner === true);

      if (!hasRole && !isPartnerAllowed) {
        return <Navigate to="/unauthorized" replace />;
      }
    }
  }

  return children;
}

const ROLE_REDIRECTS: Record<string, string> = {
  ADMIN: '/admin',
  DOCTOR: '/medico/dashboard',
  PATIENT: '/dashboard',
  SUPPORT: '/dashboard',
  FINANCE: '/admin',
  SYSTEM: '/admin',
  PARTNER: '/parceiro',
};

export function RequireGuest({ children }: { children: JSX.Element }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500" />
      </div>
    );
  }

  if (isAuthenticated && user) {
    const redirectPath = ROLE_REDIRECTS[user.role] || '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
}
